<template><span></span></template>
<script>export default {
    mounted() {
    	let lenusScript = document.createElement('script');
        lenusScript.setAttribute('id', 'lenusScript');
        lenusScript.setAttribute('src', 'https://eu.lenus.io/api/v1/22af7588-6c0c-11ed-96e3-5f2040dbee28/form/lead-form');
        document.querySelector('.zoezi-a714a2e310ccf3d1').appendChild(lenusScript);
    },
    created() {
        window.__L_QUESTIONNAIRE = {
            variables: { 
                locale: 'sv-SE',
                fbPixel: '4941411485935667',
                snapPixel: null,
                tiktokPixel: 'CDT3QQBC77U2BHNF6VQ0',
                googleAnalytics4: 'G-QZRR0X95D6'
            },
            config: {
                "options": {
                    "stepForm": true,
                    "title": null,
                    "subTitle": "Online Coaching",
                    "success": {
                        "title": "Allt klart!",
                        "body": "Du omdirigeras inom några sekunder...",
                        "redirectTo": null
                    },
                    "supportCouponCode": true
                },
                "sections": [{
                        "title": {
                            "da-DK": "Angiv dit mål",
                            "en-US": "State your goal",
                            "en-GB": "State your goal",
                            "sv-SE": "Ange din målsättning",
                            "de-DE": "Nenne dein Zeil?",
                            "fr-FR": "Indiquez votre objectif",
                            "es-ES": "Declara tu objetivo",
                            "es-MX": "Declara tu objetivo",
                            "fi-FI": "Kerro tavoitteesi",
                            "nl-NL": "Vermeld je doel",
                            "nb-NO": "Angi målet ditt"
                        },
                        "components": [{
                            "type": "custom-option-group",
                            "field": "goal",
                            "options": [{
                                "label": "Hälsosam livsstil"
                            }, {
                                "label": "Viktnedgång"
                            }, {
                                "label": "Bygga muskler"
                            }, {
                                "label": "Annat"
                            }]
                        }]
                    }, {
                        "title": {
                            "da-DK": "Jeg er",
                            "en-US": "I am",
                            "en-GB": "I am",
                            "sv-SE": "Jag är",
                            "de-DE": "Ich bin",
                            "fr-FR": "J’ai",
                            "es-ES": "Soy",
                            "es-MX": "Soy",
                            "fi-FI": "Olen",
                            "nl-NL": "Ik ben",
                            "nb-NO": "Jeg er"
                        },
                        "components": [{
                            "type": "custom-option-group",
                            "field": "age",
                            "options": [{
                                "label": "18-30"
                            }, {
                                "label": "30-45"
                            }, {
                                "label": "45-65"
                            }, {
                                "label": "65+"
                            }]
                        }]
                    }, {
                        "title": "Något mer vi behöver veta?",
                        "components": [{
                            "type": "custom-textarea",
                            "field": "Details",
                            "placeholder": "Övrigt (valfritt)",
                            "required": false,
                            "rows": 3
                        }]
                    }, {
                        "title": {
                            "da-DK": "Kontaktinformation",
                            "en-US": "Contact information",
                            "en-GB": "Contact information",
                            "sv-SE": "Kontaktuppgifter",
                            "de-DE": "Kontaktinformationen",
                            "fr-FR": "Coordonées",
                            "es-ES": "Información de contacto",
                            "es-MX": "Datos de contacto",
                            "fi-FI": "Yhteystiedot",
                            "nl-NL": "Contactinformatie",
                            "nb-NO": "Kontaktinformasjon"
                        },
                        "components": [{
                            "type": "personal-information",
                            "fields": [{
                                "name": "fullName",
                                "required": true
                            }, {
                                "name": "email",
                                "required": true
                            }, {
                                "name": "phone",
                                "required": true,
                                "internationalPhoneNumber": true
                            }, {
                                "name": "country",
                                "required": true
                            }]
                        }, {
                            "type": "custom-option-group",
                            "field": "Preferred contact",
                            "required": false,
                            "options": [{
                                "label": "Jag föredrar SMS / Epost"
                            }, {
                                "label": "Jag föredrar att bli uppringd",
                            }]
                        }]
                    }],
            }
        };
    }
}</script>